module.exports = __webpack_public_path__ + "img/1080_24.e5d3abdf.jpg";